<template>
  <v-chip :color="color" class="travel-service-chips text-center my-1" outlined>
    <v-icon class="small mr-1 my-1">{{ icon }}</v-icon>
    <span>{{ text }}</span>
  </v-chip>
</template>

<script>
import { itemsFilterStatus } from "../../staticData/ServiceOrder";

export default {
  name: "OrderChip",
  props: {
    status: {
      required: true
    }
  },
  computed: {
    itemsFilterStatus,
    statusObject() {
      return this.itemsFilterStatus.find(types => types.value === this.status);
    },
    color() {
      if (typeof this.statusObject === "undefined") return null;
      return this.statusObject.color;
    },
    icon() {
      if (typeof this.statusObject === "undefined") return null;
      return this.statusObject.icon;
    },
    text() {
      if (typeof this.statusObject === "undefined") return null;
      return this.statusObject.text;
    }
  }
};
</script>

<style scoped></style>
